// Claude: Home redirects to Login — role selection merged into login page 05-03-2026
import React from "react";
import { Navigate } from "react-router-dom";

const Home = () => <Navigate to="/login" replace />;

export default Home;
